var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "ui-form-row" },
      [
        _c("app-radios", {
          attrs: {
            name: "program-e-mentoring-service-area",
            label: _vm.t("app-e-mentoring-service-area"),
            options: _vm.options,
            required: "true",
          },
          on: { input: _vm.onChangeServiceAreaType },
          model: {
            value: _vm.program.attributes.delivery.eMentoringServiceArea,
            callback: function ($$v) {
              _vm.$set(
                _vm.program.attributes.delivery,
                "eMentoringServiceArea",
                $$v
              )
            },
            expression: "program.attributes.delivery.eMentoringServiceArea",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.program.attributes.delivery.eMentoringServiceArea ===
    "app-specific-service-area"
      ? _c(
          "div",
          [
            _c(
              "div",
              {
                staticClass:
                  "description description-row description-small description-icon description-icon-align-center description-dynamic-hint alert",
                attrs: { "data-hint-active": _vm.showPlacePickerHint },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("explore"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.t("app-program-e-mentoring-locations-description")
                    )
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("multi-place-picker", {
              attrs: {
                label: _vm.t("app-program-delivery-e-mentoring"),
                required: "true",
              },
              on: {
                remove: function ($event) {
                  return _vm.program.attributes.delivery.eMentoringLocations.splice(
                    $event,
                    1
                  )
                },
                placePickerStarted: function ($event) {
                  _vm.showPlacePickerHint = true
                },
                placePickerEnded: function ($event) {
                  _vm.showPlacePickerHint = false
                },
              },
              model: {
                value: _vm.program.attributes.delivery.eMentoringLocations,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.program.attributes.delivery,
                    "eMentoringLocations",
                    $$v
                  )
                },
                expression: "program.attributes.delivery.eMentoringLocations",
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "description description-small description-dynamic-hint alert help",
              },
              [
                _vm._v(
                  _vm._s(_vm.t("app-program-delivery-address-helper-text"))
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }